module.exports = __webpack_public_path__ + "static/media/4.b2a668db.svg";